import React from "react";
import { useState } from "react";
import "./index.css";
import { getApiData } from "../../services/index";

const GotQuestion = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Full Name validation
    if (!formData.full_name.trim()) {
      newErrors.full_name = "Full name is required";
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    // Mobile validation (basic - just checks if it's not empty and contains only numbers)
    const mobileRegex = /^[0-9+\-\s()]+$/;
    if (!formData.phone.trim()) {
      newErrors.phone = "Mobile number is required";
    } else if (!mobileRegex.test(formData.phone)) {
      newErrors.phone = "Invalid mobile number";
    }

    // message validation
    if (!formData.message.trim()) {
      newErrors.message = "message is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const { full_name, email, phone, message } = formData;
      const app = {
        full_name,
        email,
        phone,
        message,
      };
      console.log("handleSubmit: ", app);

      getApiData("api/services_enquiry", app).then((result) => {
        let responseJson = result;
        console.log("result: ", result);
        if (responseJson && result["status"] === 200) {
          alert("Form submitted");

          // Clear the form fields after successful submission
          setFormData({
            full_name: "",
            email: "",
            phone: "",
            message: "",
          });
        } else {
          alert("Form not submitted");
        }
      });
    } else {
      console.log("Form has errors");
    }
  };

  return (
    <>
      {/* got a question Section */}
      <section className="px-4 sm:px-7 md:px-16 conact-padding sm:p-9">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 md:gap-14 space-y-8 md:space-y-0">
          {/* Left Side Image and Text */}
          <div className="w-full md:w-1/2 relative">
            <div className="relative">
              <img
                src="https://res.cloudinary.com/dnu4huav1/images/c_scale,w_848,h_731,dpr_1.25/f_auto,q_auto/v1711797501/scholarships_contact_form_v2/scholarships_contact_form_v2.jpg?_i=AA"
                alt="Contact Form"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 flex flex-col justify-center items-start p-4 sm:p-8 z-10">
                <h1 className="text-white mb-2">Got a question?</h1>
                <h4 className="subhead text-white mt-4">
                  If you have any queries, please drop us a message by filling
                  out the form. We will connect you with an advisor as soon as
                  possible!
                </h4>
              </div>
            </div>
          </div>

          {/* Right Side Form */}
          <div className="w-full md:w-1/2">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2>Book a Free Session with Our Expert Counselors!</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                {/* Full Name */}
                <div className="w-full">
                  <label
                    htmlFor="firstName"
                    className="block text-sm font-medium text-gray-700"
                  ></label>
                  <input
                    type="text"
                    placeholder="Your Full Name*"
                    id="full_name"
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleChange}
                    className={`mt-1 block w-full rounded-md border ${
                      errors.full_name ? "border-red-500" : "border-gray-300"
                    } shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 min-h-9 pl-2`}
                  />
                  {errors.full_name && (
                    <p className="mt-1 text-sm text-red-500 ">
                      {errors.full_name}
                    </p>
                  )}
                </div>

                {/* Email*/}
                <div className="w-full">
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700"
                  ></label>
                  <input
                    type="email"
                    placeholder="Your Email*"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`mt-1 block w-full rounded-md border ${
                      errors.email ? "border-red-500" : "border-gray-300"
                    } shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 min-h-9 pl-2`}
                  />
                  {errors.email && (
                    <p className="mt-1 text-sm text-red-500 ">{errors.email}</p>
                  )}
                </div>

                {/* phone*/}
                <div className="w-full">
                  <label
                    htmlFor="tel"
                    className="block text-sm font-medium text-gray-700"
                  ></label>
                  <input
                    type="tel"
                    placeholder="Phone Number*"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className={`mt-1 block w-full rounded-md border ${
                      errors.phone ? "border-red-500" : "border-gray-300"
                    } shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 min-h-9 pl-2`}
                  />
                  {errors.phone && (
                    <p className="mt-1 text-sm text-red-500 ">{errors.phone}</p>
                  )}
                </div>

                {/* message*/}
                <div className="w-full">
                  <label
                    htmlFor="message"
                    className="block text-sm font-medium text-gray-700"
                  ></label>
                  <input
                    type="message"
                    placeholder="Your Message*"
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className={`mt-1 block w-full rounded-md border ${
                      errors.message ? "border-red-500" : "border-gray-300"
                    } shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 min-h-9 pl-2`}
                  />
                  {errors.message && (
                    <p className="mt-1 text-sm text-red-500 ">
                      {errors.message}
                    </p>
                  )}
                </div>

                {/* Submit Button */}
                <div className="w-full flex justify-start">
                  <button
                    type="submit"
                    className="w-48 py-2 bg-[#1D2E63] text-white font-semibold rounded-2xl hover:bg-[#162A49] focus:outline-none"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GotQuestion;
